module.exports = __webpack_public_path__ + "img/retainer_video.17618fc1.gif";